import { ObjectId } from 'bson';

export interface Tax {
  name: string;
  id: string;
  percentage: number;
  amount: string;
}

export interface Tip {
  amount: string;
  percentage: number;
}

export interface Summary {
  discountTotal: string;
  shippingTotal: string;
  total: string;
  totalTaxes: string;
  taxes: Tax[];
  subTotal: string;
  tip: Tip;
}

export interface CartDiscount {
  label: string;
  amount: string;
  percentage: number;
}

export interface PaymentMethod {
  paymentType: string;
  cashRounding: number;
  amount: string;
  transactionId: string;
  timestamp: Date;
  processor: string;
  tipAmount: string;
}

export interface PosData {
  station: ObjectId;
  outlet: ObjectId;
  employee: ObjectId;
}

export interface Metadata {
  key: string;
  value: string;
  externalId: string;
}

export interface Note {
  externalId: string;
  author: string;
  note: string;
  customerNote: boolean;
  addedByUser: string;
  dateCreated: Date;
}

export interface Billing {
  firstName: string;
  lastName: string;
  company: string;
  city: string;
  postCode: string;
  state: string;
  address1: string;
  address2?: string;
  country: string;
}

export interface Shipping {
  firstName: string;
  lastName: string;
  company: string;
  city: string;
  postCode: string;
  state: string;
  address1: string;
  address2?: string;
  country: string;
}

export interface LineItemTax {
  name: string;
  id: string;
  percentage: number;
  amount: string;
}

export interface ItemDiscount {
  percentage: number;
  amount: string;
}

export interface CartDiscount {
  percentage: number;
  amount: string;
}

export interface LineItemDiscount {
  itemDiscount: ItemDiscount;
  cartDiscount: CartDiscount;
}

export interface LineItem {
  productId: ObjectId;
  productExternalId: string;
  variantId: ObjectId;
  variantExternalId: string;
  name: string;
  manageStock: boolean;
  quantity: number;
  price: string;
  taxes: LineItemTax[];
  discount: LineItemDiscount;
  totalTax: string;
  total: string;
  metadata: Metadata[];
  image?: string;
  sku?: string;
  note?: string;
  description?: string;
}

export enum OrderSource {
  IN_STORE = 'in-store',
  WOO = 'woo-commerce',
}

export interface Order {
  _id: ObjectId;
  externalId?: string;
  receiptId?: string;
  fromOliver?: boolean;
  customerNote?: string;
  companyId: ObjectId;
  status?: string;
  customerId?: ObjectId;
  summary: Summary;
  cartDiscount?: CartDiscount;
  updatedAt?: Date;
  paymentMethods: PaymentMethod[];
  source?: OrderSource;
  posData: PosData;
  sessionId?: string;
  metadata?: Metadata[];
  notes?: Note[];
  billing?: Billing;
  shipping?: Shipping;
  lineItems: LineItem[];
  balance?: string;
  createdAt: Date;
  isDeleted?: boolean;
}

export enum OrderFilter {
  TODAY = 'today',
  THIS_WEEK = 'this week',
  THIS_MONTH = 'this month',
  THIS_YEAR = 'this year',
  All_TIME = 'all_time',
}

export interface SortOption {
  [key: string]: number;
}

export interface FinancialGridResponse {
  _id: null;
  totalRevenue: number;
  totalOrders: number;
  totalDiscounts: number;
  averageOrderCost: number;
  totalRefunds: number;
  totalCustomers: number;
}

export type Top5ProductItem = {
  productId: string;
  name: string;
  sku?: string;
  totalSales?: number;
  quantitySold?: number;
  image?: string;
};

export interface TopCustomer {
  customerId: string;
  firstName: string;
  lastName: string;
  totalSpent: number;
  orderCount: number;
  email: string;
}
